import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path stroke="#3A3A88" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h12l-4-4M16 14H4l4 4" />
  </svg>
)
export default SvgComponent
